import { createVNode, mergeProps } from "vue";
export default {
  name: 'UsersIcon',
  props: {
    size: {
      type: String,
      default: '16',
      validator: s => !isNaN(s) || s.length >= 2 && !isNaN(s.slice(0, s.length - 1)) && s.slice(-1) === 'x'
    }
  },

  setup(props, ctx) {
    const size = props.size.slice(-1) === 'x' ? props.size.slice(0, props.size.length - 1) + 'em' : parseInt(props.size) + 'px';
    const attrs = { ...ctx.attrs
    };
    attrs.width = attrs.width || size;
    attrs.height = attrs.height || size;
    return () => createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "class": "feather feather-users"
    }, { ...attrs
    }), [createVNode("path", {
      "d": "M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"
    }), createVNode("circle", {
      "cx": "9",
      "cy": "7",
      "r": "4"
    }), createVNode("path", {
      "d": "M23 21v-2a4 4 0 0 0-3-3.87"
    }), createVNode("path", {
      "d": "M16 3.13a4 4 0 0 1 0 7.75"
    })]);
  }

};